import React from 'react';
// import Hamburger from './Hamburger.jsx'
import { Link } from 'react-router-dom';
import Hamburger from './Hamburger';


function Navbar(props) {
  let handleMenuClick = () => {
    
  }
  return (
    <div class="container nav-container">
      <div class="logo">
        Studio Ghibli Films
        </div> 
      <div class="navImage">
        </div>
  </div>
  )
}

export default Navbar